import { Component, OnInit} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import { MatSelectChange } from '@angular/material/select';
import * as moment from 'moment';
import { DomSanitizer } from "@angular/platform-browser";
import { DownloadFileService } from "@shared/services/download-file.service";
import { CeoDeskService } from './../ceo-desk.service';
import { Article ,  CategoryGroup } from './../ceo-desk.model';
import {environment} from '../../../../environments/environment.prod'

@Component({
  selector: "app-article-details-mobile",
  templateUrl: "./article-details-mobile.component.html",
  styleUrls: ["./article-details-mobile.component.scss"],
})
export class ArticleDetailsMobileComponent implements OnInit {

  categoryGroup =  new CategoryGroup();

  articles: any[];

  selectedArticle: Article;

  pageUrl: string;

  isMobileView = false;

  isFeature:boolean= false;

  public inProgress:boolean = false;

  public category:string;

  public articleId:string;

  selectedArticleId : any;
  
  constructor(private route: ActivatedRoute, 
              private apiService: ApiService, 
              public sanitizer: DomSanitizer,
              private ceoDeskService:CeoDeskService,
              public downloadFileService: DownloadFileService) {}

  ngOnInit() {
    this.pageUrl = location.href;
    this.route.queryParams.subscribe((qp) => {
      if (qp["article-id"]) {
        this.categoryGroup = this.ceoDeskService.getCategoryGroup();
        this.articleId = qp["article-id"];
        this.category = qp["catergory"];
  
        if(this.categoryGroup){
          this.afterCategoryGroup();
        }else{
          this.getCategoryData();
        }
        window.scroll(0,0);
      }
    });
  }

  public afterCategoryGroup(){
    this.selectedArticle = this.categoryGroup.articleMap[this.articleId];
    this.isFeature = !!this.selectedArticle.feature;
    const articles =  this.isFeature ? this.categoryGroup.featureArticles : this.categoryGroup.articles;
    this.articles = this.enrichArticles(articles);
  }

  public enrichArticles(articles: Article[]): Article[]{
    for(const article of  articles){
      if(article.video){
        const link = "https://www.youtube.com/embed/";
        if(article.video.startsWith('https://www.youtube.com/watch?')){
        const embed = article.video.split("watch?v=")[1];
        article.video = link + embed;
        }else if(article.video.startsWith("https://youtu.be/")){
          const embed = article.video.split("https://youtu.be/")[1];
          article.video = link + embed;
        }
      }
      const diff = moment(article.modifiedDate, "DD-MM-YYYY, h:mm:ss").fromNow();
      article.translatedModifiedDate =  `${diff} . Updated`;
      this.categoryGroup.articleMap[article.id] = article;
    }
    return articles;
  }

  public getCategoryData() {
    const obj = {
      type: this.category,
      year:  "",
      month: "",
    };

    this.apiService.postData(Urls.readArticles, obj).subscribe(
      response => {
        if(response.status === 0){
          this.groupArticles(response.data.articles || [])
        }
      },
      error => {}
    )
  }

  public groupArticles(articles: Article[] ){
    this.categoryGroup = new CategoryGroup();
    this.categoryGroup.group(articles)
    this.ceoDeskService.setCategoryGroup(this.categoryGroup);
    this.afterCategoryGroup();
  }

  public downloadAsPDF(article: any) {
    if(article){
      const name = article.split("/").pop();
      this.inProgress = true;
      this.downloadFileService.export(article).subscribe(
        data=>{
          this.inProgress = false;
          const  url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
  
      }, error=>{
        this.inProgress = true;
      });
      }
    
  }
  public investOnline() {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  };

  public onSelectionChange(change: MatSelectChange) {
    this.selectedArticle = change.value;
  }

  public getSafeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public downloadFile(path, name){
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };
}
